!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("prop-types"), require("react")) : "function" == typeof define && define.amd ? define(["prop-types", "react"], t) : "object" == typeof exports ? exports["react-splitter-layout"] = t(require("prop-types"), require("react")) : e["react-splitter-layout"] = t(e["prop-types"], e.react);
}(window, function (e, t) {
  return function (e) {
    var t = {};

    function n(o) {
      if (t[o]) return t[o].exports;
      var r = t[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, o) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: o
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var o = Object.create(null);
      if (n.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        n.d(o, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return o;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 2);
  }([function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t, n) {
    e.exports = n(3);
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var o = n(1),
        r = n.n(o),
        i = n(0),
        a = n.n(i);

    function s(e) {
      var t = e.size || 0,
          n = e.percentage ? "%" : "px",
          o = "layout-pane",
          i = {};
      return e.primary ? o += " layout-pane-primary" : e.vertical ? i.height = "".concat(t).concat(n) : i.width = "".concat(t).concat(n), r.a.createElement("div", {
        className: o,
        style: i
      }, e.children);
    }

    s.propTypes = {
      vertical: a.a.bool,
      primary: a.a.bool,
      size: a.a.number,
      percentage: a.a.bool,
      children: a.a.oneOfType([a.a.arrayOf(a.a.node), a.a.node])
    }, s.defaultProps = {
      vertical: !1,
      primary: !1,
      size: 0,
      percentage: !1,
      children: []
    };
    var c = s;

    function l(e) {
      return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function u(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    function p(e) {
      return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function d(e, t) {
      return (d = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function h(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function f() {
      if (document.body.createTextRange) {
        var e = document.body.createTextRange();
        e.collapse(), e.select();
      } else window.getSelection ? window.getSelection().empty ? window.getSelection().empty() : window.getSelection().removeAllRanges && window.getSelection().removeAllRanges() : document.selection && document.selection.empty();
    }

    var y = function (e) {
      function t(e) {
        var n, o, r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), o = this, (n = !(r = p(t).call(this, e)) || "object" !== l(r) && "function" != typeof r ? h(o) : r).handleResize = n.handleResize.bind(h(h(n))), n.handleMouseMove = n.handleMouseMove.bind(h(h(n))), n.handleMouseUp = n.handleMouseUp.bind(h(h(n))), n.handleTouchMove = n.handleTouchMove.bind(h(h(n))), n.handleSplitterMouseDown = n.handleSplitterMouseDown.bind(h(h(n))), n.state = {
          secondaryPaneSize: 0,
          resizing: !1
        }, n;
      }

      var n, o, i;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && d(e, t);
      }(t, r.a.Component), n = t, (o = [{
        key: "componentDidMount",
        value: function value() {
          var e;
          if (window.addEventListener("resize", this.handleResize), document.addEventListener("mouseup", this.handleMouseUp), document.addEventListener("mousemove", this.handleMouseMove), document.addEventListener("touchend", this.handleMouseUp), document.addEventListener("touchmove", this.handleTouchMove), void 0 !== this.props.secondaryInitialSize) e = this.props.secondaryInitialSize;else {
            var t,
                n = this.container.getBoundingClientRect();
            t = this.splitter ? this.splitter.getBoundingClientRect() : {
              width: 4,
              height: 4
            }, e = this.getSecondaryPaneSize(n, t, {
              left: n.left + (n.width - t.width) / 2,
              top: n.top + (n.height - t.height) / 2
            }, !1);
          }
          this.setState({
            secondaryPaneSize: e
          });
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e, t) {
          t.secondaryPaneSize !== this.state.secondaryPaneSize && this.props.onSecondaryPaneSizeChange && this.props.onSecondaryPaneSizeChange(this.state.secondaryPaneSize), t.resizing !== this.state.resizing && (this.state.resizing ? this.props.onDragStart && this.props.onDragStart() : this.props.onDragEnd && this.props.onDragEnd());
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          window.removeEventListener("resize", this.handleResize), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("touchend", this.handleMouseUp), document.removeEventListener("touchmove", this.handleTouchMove);
        }
      }, {
        key: "getSecondaryPaneSize",
        value: function value(e, t, n, o) {
          var r, i, a, s;
          this.props.vertical ? (r = e.height, i = t.height, a = n.top - e.top) : (r = e.width, i = t.width, a = n.left - e.left), o && (a -= i / 2), a < 0 ? a = 0 : a > r - i && (a = r - i);
          var c = r - i - (s = 1 === this.props.primaryIndex ? a : r - i - a);
          return this.props.percentage && (s = 100 * s / r, c = 100 * c / r, i = 100 * i / r, r = 100), c < this.props.primaryMinSize ? s = Math.max(s - (this.props.primaryMinSize - c), 0) : s < this.props.secondaryMinSize && (s = Math.min(r - i - this.props.primaryMinSize, this.props.secondaryMinSize)), s;
        }
      }, {
        key: "handleResize",
        value: function value() {
          if (this.splitter && !this.props.percentage) {
            var e = this.container.getBoundingClientRect(),
                t = this.splitter.getBoundingClientRect(),
                n = this.getSecondaryPaneSize(e, t, {
              left: t.left,
              top: t.top
            }, !1);
            this.setState({
              secondaryPaneSize: n
            });
          }
        }
      }, {
        key: "handleMouseMove",
        value: function value(e) {
          if (this.state.resizing) {
            var t = this.container.getBoundingClientRect(),
                n = this.splitter.getBoundingClientRect(),
                o = this.getSecondaryPaneSize(t, n, {
              left: e.clientX,
              top: e.clientY
            }, !0);
            f(), this.setState({
              secondaryPaneSize: o
            });
          }
        }
      }, {
        key: "handleTouchMove",
        value: function value(e) {
          this.handleMouseMove(e.changedTouches[0]);
        }
      }, {
        key: "handleSplitterMouseDown",
        value: function value() {
          f(), this.setState({
            resizing: !0
          });
        }
      }, {
        key: "handleMouseUp",
        value: function value() {
          this.setState(function (e) {
            return e.resizing ? {
              resizing: !1
            } : null;
          });
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              t = "splitter-layout";
          this.props.customClassName && (t += " ".concat(this.props.customClassName)), this.props.vertical && (t += " splitter-layout-vertical"), this.state.resizing && (t += " layout-changing");
          var n = r.a.Children.toArray(this.props.children).slice(0, 2);
          0 === n.length && n.push(r.a.createElement("div", null));

          for (var o = [], i = 0 !== this.props.primaryIndex && 1 !== this.props.primaryIndex ? 0 : this.props.primaryIndex, a = 0; a < n.length; ++a) {
            var s = !0,
                l = null;
            n.length > 1 && a !== i && (s = !1, l = this.state.secondaryPaneSize), o.push(r.a.createElement(c, {
              vertical: this.props.vertical,
              percentage: this.props.percentage,
              primary: s,
              size: l
            }, n[a]));
          }

          return r.a.createElement("div", {
            className: t,
            ref: function ref(t) {
              e.container = t;
            }
          }, o[0], o.length > 1 && r.a.createElement("div", {
            role: "separator",
            className: "layout-splitter",
            ref: function ref(t) {
              e.splitter = t;
            },
            onMouseDown: this.handleSplitterMouseDown,
            onTouchStart: this.handleSplitterMouseDown
          }), o.length > 1 && o[1]);
        }
      }]) && u(n.prototype, o), i && u(n, i), t;
    }();

    y.propTypes = {
      customClassName: a.a.string,
      vertical: a.a.bool,
      percentage: a.a.bool,
      primaryIndex: a.a.number,
      primaryMinSize: a.a.number,
      secondaryInitialSize: a.a.number,
      secondaryMinSize: a.a.number,
      onDragStart: a.a.func,
      onDragEnd: a.a.func,
      onSecondaryPaneSizeChange: a.a.func,
      children: a.a.arrayOf(a.a.node)
    }, y.defaultProps = {
      customClassName: "",
      vertical: !1,
      percentage: !1,
      primaryIndex: 0,
      primaryMinSize: 0,
      secondaryInitialSize: void 0,
      secondaryMinSize: 0,
      onDragStart: null,
      onDragEnd: null,
      onSecondaryPaneSizeChange: null,
      children: []
    };
    var m = y;
    t.default = m;
  }]);
});